import {
    GET_LIST_DISEASES,
    GET_SPECIFIC_DISEASES,
    UPDATE_SPECIFIC_DISEASES,
    CREATE_NEW_DISEASES,
    REMOVE_DISEASES,
    GET_DISEASES_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    diseases_list: [],
    currentDiseases: null,
    diseases_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_DISEASES: {
            return {
                ...state,
                diseases_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_DISEASES_ACTIVE: {
            return {
                ...state,
                diseases_active_list: action.payload.data,
            }
        }
        case GET_SPECIFIC_DISEASES: {
            return { ...state, currentDiseases: action.payload }
        }
        case CREATE_NEW_DISEASES: {
            return {
                ...state,
                diseases_list: [action.payload, ...state.diseases_list],
                diseases_active_list: [action.payload, ...state.diseases_active_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_DISEASES: {
            let index = state.diseases_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.diseases_list];
            temp[index] = action.payload;
            //
            let index2 = state.diseases_active_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.diseases_active_list];
            temp[index2] = action.payload;

            return { ...state, diseases_list: temp, diseases_active_list: temp2 }
        }
        case REMOVE_DISEASES: {
            let temp = state.diseases_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.diseases_active_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, diseases_list: temp, diseases_active_list: temp2 }
        }
        default: return { ...state };
    }
}
